var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\bavoassistant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37254"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463340",
    x: 7.5,
    y: 8.83301,
    width: 35,
    height: 35,
    rx: 1,
    fill: "white",
    stroke: "#23C29D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7268 37.275H27.5753V34.7754H37.7268V37.275Z",
    fill: "#23C29D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7268 31.8168H27.5753V29.2662H37.7268V31.8168Z",
    fill: "#23C29D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2727 19.8288H23.6868V17.2783H12.2727V19.8288ZM16.7171 39.06H19.2424V34.571H23.6868V32.0205H19.2424V27.5315H16.7171V32.0205H12.2727V34.571H16.7171V39.06ZM29.4444 23.5016L32.5252 20.3899L35.606 23.5016L37.4242 21.6652L34.3434 18.5535L37.4242 15.4419L35.606 13.6055L32.5252 16.7171L29.4444 13.6055L27.6262 15.4419L30.707 18.5535L27.6262 21.6652L29.4444 23.5016Z",
    fill: "#23C29D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorGreen);
export default __webpack_public_path__ + "static/media/calculator-green.e8fce532cdf2828d2d8df273aa527fc4.svg";
export { ForwardRef as ReactComponent };